import { render, staticRenderFns } from "./RirsTablePositionsTable.vue?vue&type=template&id=4e54f105&scoped=true"
import script from "./RirsTablePositionsTable.vue?vue&type=script&lang=js"
export * from "./RirsTablePositionsTable.vue?vue&type=script&lang=js"
import style0 from "./RirsTablePositionsTable.vue?vue&type=style&index=0&id=4e54f105&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e54f105",
  null
  
)

export default component.exports